import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  showPopulationDensityTable: false,
  showPopulationDistributionTable: false,
  showRiskOverTimeTable: false,
  showPopulationOverTimeTable: false,
  selectedLabel: {orderBy: 'population', order: 'dsc'}
}

const tableViewSlice = createSlice({
  name: 'tableView',
  initialState,
  reducers: {
    setShowPopulationDensityTable: (state, action) => {
      state.showPopulationDensityTable = action.payload
    },
    setShowPopulationDistributionTable: (state, action) => {
      state.showPopulationDistributionTable = action.payload
    },
    setShowRiskOverTimeTable: (state, action) => {
      state.showRiskOverTimeTable = action.payload
    },
    setShowPopulationOverTimeTable: (state, action) => {
      state.showPopulationOverTimeTable = action.payload
    },
    setSelectedLabel: (state, action) => {
      state.selectedLabel = action.payload
    },
    clearTableView: (state) => {
      state.showPopulationDensityTable = false
      state.showPopulationDistributionTable = false
      state.showRiskOverTimeTable = false
      state.showPopulationOverTimeTable = false
      state.selectedLabel = {orderBy: 'population', order: 'dsc'}
    }
  }
})

export const {
  setShowPopulationDensityTable,
  setShowPopulationDistributionTable,
  setShowRiskOverTimeTable,
  setShowPopulationOverTimeTable,
  setSelectedLabel,
  clearTableView
} = tableViewSlice.actions

export const selectShowPopulationDensityTable = (state) => state.tableView.showPopulationDensityTable
export const selectShowPopulationDistributionTable = (state) => state.tableView.showPopulationDistributionTable
export const selectShowRiskOverTimeTable = (state) => state.tableView.showRiskOverTimeTable
export const selectShowPopulationOverTimeTable = (state) => state.tableView.showPopulationOverTimeTable
export const selectSelectedLabel = (state) => state.tableView.selectedLabel

export default tableViewSlice.reducer
